import { InputItem } from "pepsico-ds";
import PropTypes from "prop-types";
import "./InputText.scss";

const InputText = ({
  label,
  placeholder,
  size = "medium",
  onChange,
  name,
  value,
  errorMessage,
  required = false,
  className = "",
  disabled = false,
  ...otherProps
}) => {
  return (
    <div className={`input-text-container ${className}`}>
      {label && label !== null && (
        <label htmlFor={name}>
          <div>{label}</div>
          {required && <div className="required">Required</div>}
        </label>
      )}
      <InputItem
        className="input-text-field"
        placeholderText={placeholder}
        size={size}
        onChange={onChange}
        name={name}
        value={value || ""}
        label={label}
        error={!!errorMessage}
        required={required}
        disabled={disabled}
        id={name}
        {...otherProps}
      />
      {errorMessage && (
        <p className="error-message" role="alert">
          {errorMessage}
        </p>
      )}
    </div>
  );
};

InputText.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

export default InputText;
